export default __webpack_public_path__ + "static/media/hero_caracal_one.96ea3363.jpg";